// Fetches the full pool of accessories of a given type for a model.
export const getAccessoriesByType = async ({ accessoryType, modelNo }) => {
  if (!modelNo) {
    return null;
  }
  const response = await fetch(`/api/accessories/${modelNo}/${accessoryType}`, {
    method: 'GET',
    headers: { 'Content-type': 'application/json' },
  });
  if (!response.ok) {
    throw new Error(`Accessories request failed with status ${response.status}`);
  }
  const data = await response.json();
  return data || null;
};
